<div class="d-flex align-items-start applied-filter-wrapper" *ngIf="isShowFiltersContainer">
  <div class="text-nowrap">
  <h4 id="appliedFilters" class="c11n-text-md-normal applied-filter-label">{{fd3ContentGenericListResponse.appliedFilters}}</h4>
  </div>
  <div role="group" aria-label="Applied filters">
    <c11n-chip-group aria-labelledby="appliedFilters" [defaultFocusableSelector]="'.c11n-storybook-chip__refresh'" (stateChange)="removeAppliedFilterChipAction($event);">
    <c11n-chip *ngIf="appliedFiltersPrdct && appliedFiltersPrdct.id !== defaultProductType" [labelText]=appliedFiltersPrdct.text [size]="'small'" [color]="'ink'"
               [action]="'removable'"></c11n-chip>
    <ng-template ngFor let-filterByKey [ngForOf]="filterByList">
      <c11n-chip *ngIf="filterBy.filterByLevel1[filterByKey].value" [labelText]=filterBy.filterByLevel1[filterByKey].text [size]="'small'" [color]="'ink'"
                 [action]="'removable'"></c11n-chip>
      <ng-container *ngIf="filterBy.filterByLevel1[filterByKey].value">
        <ng-template ngFor let-level2 [ngForOf]="filterBy.filterByLevel1[filterByKey].level2">
          <c11n-chip *ngIf="level2.value" [labelText]=level2.text [size]="'small'" [color]="'ink'"
                     [action]="'removable'"></c11n-chip>
        </ng-template>
      </ng-container>
    </ng-template>

  </c11n-chip-group>
  </div>
<div class="clear-all-wrapper">
  <a role="button" class="c11n-link c11n-text-sm-bold applied-filter-clearAll" href="javascript:void(0);" (click)="clearAllFilter()" >
      <span class="c11n-link__content">
        <span class="sr-only">{{fd3ContentGenericListResponse.appliedFilters}} &nbsp;</span>
        {{ fd3ContentGenericListResponse.clearAll }}
        <span class="sr-only">&nbsp;Chips</span>
      </span>
  </a>
</div>
</div>
